module.exports = __webpack_public_path__ + "static/media/img.0f159105.png";